import { frontendURL } from '../../../helper/URLHelper';
import NotificationsIndex from './pages/NotificationsIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/notifications'),
    name: 'notifications_index',
    component: NotificationsIndex,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
